import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Suspense as _Suspense, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary" }, "Medsafe PRO 2.0", -1)
const _hoisted_2 = { class: "copyright" }

import { computed, onBeforeMount, ref } from 'vue';

import ModalContainer from '~components/modals/ModalContainer.vue';
import { useMainStore } from '@/store';
import { useAuthStore } from '@/store/auth/authModule';
import { storeToRefs } from 'pinia';
import AppLoader from '~components/AppLoader.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { height, tabsHeaderHeight } from './constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "61751ba0": (wrapperStyleHeight),
  "b96efe64": (tabsWrapperStyleHeight)
}))

let AUTH_HOST = window.location.origin;
if (AUTH_HOST.indexOf('localhost') !== -1) {
  AUTH_HOST = 'http://localhost:8081';
}

const authStore = useAuthStore();

const isLoading = ref(false);

const { isAuth } = storeToRefs(authStore);

const authInProcess = ref(false);

const openLoginPopup = () => {
  const receiveMessage = async (event: MessageEvent) => {
    if (event.data === 'login') {
      await authStore.autenticate();
    }
  };
  const windowFeatures = 'popup, scrollbars=yes, resizable=yes, toolbar=1 menubar=yes';
  const authWindow = window.open(`${AUTH_HOST}/login`, 'Auth', windowFeatures);
  if (authWindow) {
    window.addEventListener('message', receiveMessage);
  }
};

onBeforeMount(async () => {
  isLoading.value = true;
  await authStore.autenticate();
  isLoading.value = false;
});

const { modal, maximized, messages } = storeToRefs(useMainStore());

const messageShown = computed(() => Boolean(messages.value.length));

const closeModal = () => {
  useMainStore().closeModal();
};

const { hideMessage } = useMainStore();

const wrapperStyleHeight = `calc(100vh - ${height}px)`;
const tabsWrapperStyleHeight = `calc(100vh - ${height + tabsHeaderHeight}px)`;

return (_ctx: any,_cache: any) => {
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "lHh Lpr lFf" }, {
    default: _withCtx(() => [
      (_unref(isAuth) && !authInProcess.value)
        ? (_openBlock(), _createBlock(BaseLayout, {
            key: 0,
            isLoading: isLoading.value
          }, null, 8, ["isLoading"]))
        : (_openBlock(), _createBlock(AuthLayout, {
            key: 1,
            onOpenLoginPopup: openLoginPopup
          })),
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_q_inner_loading, {
            key: 2,
            showing: isLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(AppLoader)
            ]),
            _: 1
          }, 8, ["showing"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_footer, { class: "bg-grey-3 text-primary" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_q_space),
              _createElementVNode("div", _hoisted_2, "Copyright © 2011-" + _toDisplayString(new Date().getFullYear()) + " · MedSafe LLC", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_dialog, {
        modelValue: _unref(modal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modal) ? (modal).value = $event : null)),
        "full-height": _unref(maximized),
        "full-width": _unref(maximized)
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(ModalContainer, { onClose: closeModal })
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["modelValue", "full-height", "full-width"]),
      _createVNode(_component_q_dialog, {
        modelValue: _unref(messageShown),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(messageShown) ? (messageShown).value = $event : null)),
        seamless: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (item) => {
            return (_openBlock(), _createBlock(_component_q_card, {
              key: item.id,
              class: "row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.content), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  icon: "close",
                  onClick: ($event: any) => (_unref(hideMessage)(item.id))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})